<template>
  <div class="criterio-input-produtos">
    <span v-if="label" class="criterio-subtitle"> {{ label }} </span>

    <v-flex xs12>
      <modal-graphql-search-content
        v-if="!viewOnly"
        :selected-items.sync="products"
        item-type="produto"
        :disable-save="disableSave"
        :tooltip-primary-button="tooltipPrimaryButton"
        :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
        :placeholder="placeholder"
        hide-details
        @input="updateProductsValue"
      />
      <modal-view-items
        v-else
        buttonText="Ver produtos"
        table-title="Lista de produtos"
        search-placeholder="Busque um produto"
        :headers="headers"
        :items="products"
      />
    </v-flex>
  </div>
</template>

<script>
import ModalGraphqlSearchContent from '@/components/ModalGraphqlSearchContent.vue'
import ModalViewItems from '@/components/ModalViewItems.vue'
import gql from 'graphql-tag'

export const QUERY_PRODUCTS = gql`
  query Products($skus: [String]) {
    products(skus: $skus) {
      products {
        _id
        sku
        ean
        eans
        name
      }
    }
  }
`
export default {
  components: {
    ModalGraphqlSearchContent,
    ModalViewItems,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: Array,
    disableSave: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: String,
      validator: (val) => ['allowEmpty'].includes(val),
    },
  },

  data: () => ({
    products: [],
  }),

  computed: {
    headers() {
      return [
        {
          text: 'SKU',
          align: 'start',
          sortable: false,
          value: 'sku',
          width: '10%',
        },
        {
          text: 'EAN',
          align: 'start',
          sortable: false,
          value: 'ean',
          width: '10%',
        },
        {
          text: 'Nome',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '80%',
        },
      ]
    },
    placeholder() {
      if (this.componentParams === 'allowEmpty') {
        return 'Todos os produtos'
      }
      return ''
    },
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  async mounted() {
    if (this.initialValue) {
      await this.getSelectedProducts()
    }
    this.validate()
  },

  methods: {
    updateProductsValue() {
      const productsToSave = this.products.map((product) => {
        return product.sku
      })

      this.$emit('input', { currentValue: productsToSave, currentChildren: this.values && this.values[0], currentIndex: this.currentIndex })

      this.validate()
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      if (this.componentParams === 'allowEmpty') {
        return true
      }
      return Boolean(this.products && this.products.length)
    },
    async getSelectedProducts() {
      try {
        const {
          data: {
            products: { products: productsArray },
          },
        } = await this.$apollo.query({
          query: QUERY_PRODUCTS,
          variables: {
            skus: this.initialValue,
          },
          fetchPolicy: 'no-cache',
        })
        if (productsArray && productsArray.length) {
          this.products = productsArray
        }
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao carregar produtos, tente novamente mais tarde.', snackbarColor: 'error' })
      } finally {
        this.validate()
      }
    },
  },
}
</script>

<style lang="scss">
.criterio-input-produtos {
  .v-input__control {
    padding: 5px 0 !important;
  }
}
</style>
